import { getWebSocketUrl } from '@/config/runtimeConfig'

export interface WebSocketConfig {
  url: string
  path: string
  autoConnect: boolean
  reconnection: boolean
  reconnectionAttempts: number
  reconnectionDelay: number
  timeout: number
  transports: string[]
}

export const websocketConfig: WebSocketConfig = {
  // P12-TEST1A-FE3: lazy enumerable getter — importing this module must not resolve the WS URL
  // at module evaluation (closes the release runtime-resolver TDZ class).
  get url() { return getWebSocketUrl() },
  path: '/socket.io/',
  autoConnect: false, // Manual control
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
  timeout: 20000,
  transports: ['websocket', 'polling']
}

export const channels = {
  // Sistema
  SYSTEM_ADMIN: 'system:admin',
  SYSTEM_BROADCAST: 'system:broadcast',
  SYSTEM_MAINTENANCE: 'system:maintenance',
  
  // Dashboards
  DASHBOARD_GENERAL: 'dashboard:general',
  DASHBOARD_SUPER_ADMIN: 'dashboard:super_admin',
  DASHBOARD_GROUP_MANAGER: 'dashboard:group_manager',
  DASHBOARD_FIELD_SUPERVISOR: 'dashboard:field_supervisor',
  
  // Operaciones
  OPERATIONS_MANAGEMENT: 'operations:management',
  OPERATIONS_FIELD: 'operations:field',
  
  // Tiempo real
  REALTIME_INCIDENCES: 'realtime:incidence_update',
  REALTIME_ASSIGNMENTS: 'realtime:assignment_update',
  REALTIME_GROUPS: 'realtime:group_update',
  REALTIME_DASHBOARD: 'realtime:dashboard_update',
  REALTIME_NOTIFICATIONS: 'realtime:notification'
} as const

export type ChannelType = typeof channels[keyof typeof channels]
